import React from "react";
import {Row, Col, Visible} from "react-grid-system";
import {Spacer, SubTitle, Text, ThirdTitle} from "@dspworkplace/ui";
import {BigTitle, Container} from "../../Components/UI";
import {phone, salesEmail, supportEmail} from "../../Conf";
import Footer from "../../Components/Sections/Footer";
import { InlineWidget } from "react-calendly";

const App = () => {
    return (
        <>
            <Container>
                <Row>
                    <Col md={3} push={{md: 9}}>
                        <Visible lg xl xxl>
                            <Spacer top={42}/>
                        </Visible>
                        <SubTitle>Sales</SubTitle>
                        <Spacer bottom={2}/>
                        <Text>{salesEmail}</Text>
                        <Spacer bottom={1}/>
                        <Text>{phone}</Text>
                        <Spacer bottom={5}/>
                        <SubTitle>Customer support</SubTitle>
                        <Spacer bottom={2}/>
                        <Text>{supportEmail}</Text>
                    </Col>
                    <Col md={9} pull={{md: 3}}>
                        <Spacer top={20} bottom={5}>
                            <BigTitle>Schedule a Demo</BigTitle>
                        </Spacer>
                        <Spacer bottom={10}>
                            <Text>
                                We understand that sometimes you just have to see things to believe them. At the start of every demo we ask you what you need to see--you are in charge!
                            </Text>
                            <Spacer bottom={5} />
                            <Text>
                                Our demos are scheduled for 45 minutes, but we will take only as much time as you need. The demo allows us to understand your concerns, explain how our app will address your needs, and maybe even show you a few tricks!
                            </Text>
                            <Spacer bottom={5} />
                            <Text>
                                Please select a day and time below that works for you or feel free to contact us via email or phone.
                            </Text>
                        </Spacer>
                        <div className="App">
                            <InlineWidget url="https://calendly.com/dspworkplace/dspworkplace-demo" />
                        </div>
                    </Col>
                </Row>
            </Container>

            <Spacer top={20}/>

            <Footer/>
        </>
    )
};

export default App;